import { render, staticRenderFns } from "./AppAlarmPop.vue?vue&type=template&id=a0a5024a&scoped=true"
import script from "./AppAlarmPop.vue?vue&type=script&lang=js"
export * from "./AppAlarmPop.vue?vue&type=script&lang=js"
import style0 from "./AppAlarmPop.vue?vue&type=style&index=0&id=a0a5024a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a5024a",
  null
  
)

export default component.exports